import Vue from 'vue'
import store from '~/store'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: {}
})

/**
* @param {String} locale
*/
export async function loadMessages (locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    await reloadMessages(locale)
  }

  if (i18n.locale !== locale) {
    i18n.locale = locale
  }
}

export async function reloadMessages (locale) {
  // Load static messages.

  const messagesBase = await import(/* webpackChunkName: "lang-[request]" */ `~/lang/${locale}/${locale}`)
  const messagesISCO = await import(`~/lang/${locale}/isco`)

  // TODO : Switch 'fr' to ${locale} once translations are made.
  const messagesEvaluations = {
    'evaluations': {
      'abilities': {
        'titles': await import(`~/lang/${locale}/abilities_titles`),
        'descriptions': await import(`~/lang/${locale}/abilities_descriptions`)
      },
      'requirements': {
        'titles': await import(`~/lang/${locale}/requirements_titles`),
        'descriptions': await import(`~/lang/${locale}/requirements_descriptions`)
      },
      'perceptions': {
        'titles': await import(`~/lang/${locale}/perceptions_titles`),
        'descriptions': await import(`~/lang/${locale}/perceptions_descriptions`)
      },
      'coefficients': await import(`~/lang/${locale}/coefficients`)
    }
  }

  // Load static messages from database.

  const messagesLanguages = {
    'languages': await import(`~/lang/${locale}/languages`)
  }

  const messagesNationalities = {
    'nationalities': await import(`~/lang/${locale}/nationalities`)
  }

  const messagesAccompanyingSheet = {
    'accompanying_sheet': await import(`~/lang/${locale}/accompagnying_sheet`)
  }

  const messagesComponents = {
    'components': {
      'evaluations': {
        'perceptions': await import(`~/lang/${locale}/components/evaluations/perceptions`),
        'requirements': await import(`~/lang/${locale}/components/evaluations/requirements`),
        'skills': await import(`~/lang/${locale}/components/evaluations/skills`)
      }
    }
  }

  const messagesPages = {
    'pages': {
      'welcome': await import(`~/lang/${locale}/pages/welcome`)
    }
  }

  const messagesOrigins = {
    'origins': await import(`~/lang/${locale}/origin_types`)
  }

  // Merge and store messages.

  const messages = Object.assign(
    {},
    messagesBase,
    messagesISCO,
    messagesLanguages,
    messagesNationalities,
    messagesEvaluations,
    messagesAccompanyingSheet,
    messagesComponents,
    messagesPages,
    messagesOrigins
  )

  i18n.setLocaleMessage(locale, messages)
}

export function translateAndSort (messages, baseIdentifier) {
  var translatedAndSorted = []

  // Translate
  for (var i = 0; i < messages.length; i++) {
    translatedAndSorted[i] = { 'id': messages[i].id, 'name': i18n.t(baseIdentifier + '.' + messages[i].id) }
  }

  // Sort
  translatedAndSorted.sort(function (a, b) {
    var textA = a.name.toUpperCase()
    var textB = b.name.toUpperCase()
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
  })

  return translatedAndSorted
}

;(async function () {
  await loadMessages(store.getters['lang/locale'])
})()

export default i18n



// WEBPACK FOOTER //
// ./resources/js/plugins/i18n.js